import * as brandColors from '../../../utils/brand-colors';

const drawerWidth = 260;
const drawerClosedWidth = 52;

export default (theme) => ({
  container: {
    color: 'white',
    display: 'block',
    '&::after': {
      display: 'block',
      content: "''",
      clear: 'both',
      width: '100%',
    },
    '@media print': { display: 'none' },
  },
  appBar: {
    background: brandColors.primary.main,
    zIndex: 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarDrawerOpen: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBarDrawerClosed: {
    marginLeft: drawerClosedWidth,
    width: `calc(100% - ${drawerClosedWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  menuButton: {
    marginLeft: -12,
    color: 'white',
  },
  title: { color: 'white' },
  grow: { flex: 1 },
  childrenContainer: {
    color: 'white',
    padding: '0 1.5rem .5rem',
  },
  childrenContainerNoGutter: {
    color: 'white',
    padding: '0 1.5rem',
  },
  childrenContainerNoPadding: {
    color: 'white',
    padding: 0,
  },
  progress: { height: 3 },
});
